import { connect } from 'react-redux';
import { getState as getModals } from '../../modules/modal/selectors';
import { closeModal } from '../../modules/modal/actions';
import ModalProvider from './ModalProvider';
const mapState = (state) => ({
    modals: getModals(state)
});
const mapDispatch = (dispatch) => ({
    onClose: (name) => dispatch(closeModal(name))
});
export default connect(mapState, mapDispatch)(ModalProvider);
//# sourceMappingURL=ModalProvider.container.js.map